export const faqConstants = {
    GET_FAQ_CONTENT_ACTION_REQUEST: 'GET_FAQ_CONTENT_ACTION_REQUEST',
    GET_FAQ_CONTENT_ACTION_SUCCESS: 'GET_FAQ_CONTENT_ACTION_SUCCESS',
    GET_FAQ_CONTENT_ACTION_FAILURE: 'GET_FAQ_CONTENT_ACTION_FAILURE'
}